unit uMenuReportes;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.pngimage, Vcl.Controls,
  WEBLib.Buttons;

type
  TFMenuReportes = class(TForm)
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FMenuReportes: TFMenuReportes;

implementation

uses uRep1, uRepEntEmp;

{$R *.dfm}

procedure TFMenuReportes.WebSpeedButton10Click(Sender: TObject);
begin
FMenuReportes.Hide;
end;

procedure TFMenuReportes.WebSpeedButton11Click(Sender: TObject);
begin

    TFRep1.CreateNew(
      procedure(AForm: TObject)
      begin
        FRep1 := TFRep1(AForm);
        FRep1.Show;
      end);
end;

procedure TFMenuReportes.WebSpeedButton2Click(Sender: TObject);
Var
Opcion, URL : string;
begin
Opcion:='RepDoc';

URL := 'http://207.244.241.82:9000/PDFReporteQR?Opcion='+Opcion;
  asm
  window.open(URL, '_blank');
  end;
end;

procedure TFMenuReportes.WebSpeedButton5Click(Sender: TObject);
begin
    TFRepEntEmp.CreateNew(
      procedure(AForm: TObject)
      begin
        FRepEntEmp := TFRepEntEmp(AForm);
        FRepEntEmp.Show;
      end);
end;

procedure TFMenuReportes.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);

  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  try
    Name := 'FMenuReportes';
    Width := 937;
    Height := 794;
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 18;
    WebSpeedButton11.Top := 30;
    WebSpeedButton11.Width := 239;
    WebSpeedButton11.Height := 44;
    WebSpeedButton11.Caption := 'Reporte falta de entrenamiento';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 18;
    WebSpeedButton10.Top := 330;
    WebSpeedButton10.Width := 119;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 18;
    WebSpeedButton1.Top := 80;
    WebSpeedButton1.Width := 239;
    WebSpeedButton1.Height := 44;
    WebSpeedButton1.Caption := 'Reporte de porcentajes';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Enabled := False;
    WebSpeedButton1.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 18;
    WebSpeedButton2.Top := 130;
    WebSpeedButton2.Width := 239;
    WebSpeedButton2.Height := 44;
    WebSpeedButton2.Caption := 'Reporte de documentos';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 18;
    WebSpeedButton3.Top := 180;
    WebSpeedButton3.Width := 239;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Reporte por mes';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Enabled := False;
    WebSpeedButton3.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(Self);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 18;
    WebSpeedButton4.Top := 230;
    WebSpeedButton4.Width := 239;
    WebSpeedButton4.Height := 44;
    WebSpeedButton4.Caption := 'Reporte de vencimientos';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Enabled := False;
    WebSpeedButton4.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(Self);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 18;
    WebSpeedButton5.Top := 280;
    WebSpeedButton5.Width := 239;
    WebSpeedButton5.Height := 44;
    WebSpeedButton5.Caption := 'Reporte entrenamientos por empleado';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uMenuReportes.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
  finally
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
  end;
end;

end.